import defer from './utils/defer';
/**
 * @ngdoc service
 * @name proximus.core.applicationversion:ApplicationVersionService
 * @description
 * # ApplicationVersionService
 * Sets current application version to entity manager
 */
export default class ApplicationVersionService {
    constructor(configurationService, storage) {
        this.configurationService = configurationService;
        this.storage = storage;
        this._configurationService = this.configurationService;
        this._storage = this.storage;
    }
    clearLocalStorageOnVersionChange() {
        const deferred = defer();
        const applicationName = this._configurationService.getApplicationName();
        this._storage
            .getItem(applicationName, this._configurationService.getApplicationVersionStorageStrategy())
            .then(appVersion => {
            if (appVersion === this._configurationService.getApplicationVersion()) {
                deferred.resolve(true);
            }
            else {
                //case where no app version defined and clearStorageIfVersionIsMissing set to false
                if (!appVersion && !this._configurationService.clearStorageIfVersionIsMissing()) {
                    this.setVersionToLocalStorage(deferred);
                }
                else {
                    this._configurationService.onApplicationVersionChange().then(() => {
                        deferred.resolve(true);
                    });
                }
            }
        })
            .catch(() => {
            this.setVersionToLocalStorage(deferred);
        });
        return deferred.promise;
    }
    setVersionToLocalStorage(deferred) {
        this._storage
            .setItem(this._configurationService.getApplicationName(), this._configurationService.getApplicationVersion(), this._configurationService.getApplicationVersionStorageStrategy())
            .then(() => {
            deferred.resolve(true);
        })
            .catch(error => {
            deferred.reject(error);
        });
    }
}
